import { __assign } from "tslib";
import React from 'react';
import { PinAll } from '@marvelapp/ui';
export default function TransparentBorder(props) {
    return (React.createElement(PinAll, __assign({ border: "1px solid", borderColor: "rgba(0, 0, 0, 0.15)", borderRadius: 1, pointerEvents: "none" }, props)));
}
